module.exports = __webpack_public_path__ + "media/assets/images/logo-votorantim-4ac589d4a04aa567747e3ddec12e5081.svg";